import React, { Component } from 'react'

import ProjectProgressItem from 'sections/dashboard/dashboard-project-progress-item'
import SectionControls from 'components/controls/section-controls'

import AlertBanner from 'components/alerts/alert-banner'

export default class SingleTeamProjects extends Component {
	state = {
		searchTerm: ''
	}

	onSearchTermChange = searchTerm => {
		this.setState({
			searchTerm
		})
	}

	assignProjects = _ => {
		this.props.openModal('assign', 'assign-projects', {
			team: this.props.team,
			type: 'team'
		})
	}

	render() {
		const {
			team,
			canEditTeam
		} = this.props

		const {
			searchTerm
		} = this.state

		const buttonProps = canEditTeam ? [{
			size: 'big',
			level: 'high',
			label: 'Assign projects',
			icon: 'star',
			callback: this.assignProjects
		}] : []

		return (
			<div>
				<SectionControls 
					searchTerm={searchTerm} 
					onSearchTermChange={this.onSearchTermChange} 
					buttons={buttonProps}
				/>
				{ !team.projectIds.length && 
					<AlertBanner
						low={false} 
						title={"Nothing to see here."} 
						body={`${team.name} hasn't been assigned any projects.`} 
					/>
				}
				<ul
					className="project-progress-list"
				>
					{ team.projectIds.map(projectId => {
						return (
							<ProjectProgressItem 
								projectId={projectId} 
								key={projectId} 
							/>
						)
					})}
				</ul>
			</div>
		)
	}
}
